module.exports = __webpack_public_path__ + "assets/overlay--rocket.5d78ffbb0eb09bbde4375c892799a781.svg";


//////////////////
// WEBPACK FOOTER
// ../static/images/overlays/overlay--rocket.svg
// module id = 439
// module chunks = 0